import { useQuery } from "@tanstack/react-query";
import { AdminSecurity } from "@/lib/rpc/admin-api";
import { DEV_ADMIN_CONFIG, isAdminInDev } from "@/lib/dev/auto-admin";

export function useIsAdmin() {
  return useQuery({
    queryKey: ["is-admin"],
    queryFn: async () => {
      // Development mode auto-admin
      if (DEV_ADMIN_CONFIG.enabled && DEV_ADMIN_CONFIG.bypassAuth) {
        console.log('[useIsAdmin] 🔓 DEV MODE: Auto-admin enabled');
        return true;
      }
      
      // Production mode - real admin check
      const { data, error } = await AdminSecurity.isAdminSimple();
      if (error) {
        console.warn('[useIsAdmin] Admin check failed:', error);
        return false;
      }
      return Boolean(data);
    },
    staleTime: 0,
    gcTime: 0,
    refetchOnMount: "always",
    refetchOnWindowFocus: true,
    suspense: false, // Prevent React error #300 during auth transitions
  });
}